/**
 * API configuration and base URL resolution.
 *
 * Implements clean architectural separation:
 * - Frontend SPA: atlantacardsharks.com -> Firebase Hosting (static assets)
 * - Backend API:  api.atlantacardsharks.com -> Google Cloud Run (.NET 10 Web API)
 */

export function getApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const envBase = (import.meta as any).env?.VITE_API_BASE_URL;
    if (envBase && !envBase.includes('atlantacardsharks.com')) {
      return envBase.replace(/\/+$/, '');
    }
  }

  // Returns empty string to use origin-relative paths (/api/...).
  // Firebase Hosting rewrites /api/** directly to Google Cloud Run (atlcardsharks-api)
  // which guarantees zero-configuration resilience across all devices, mobile carriers, and ISPs.
  return '';
}

/**
 * Resolves an API path to an absolute or origin-relative URL.
 * Handles paths with or without a leading '/api'.
 *
 * Examples:
 *   getApiUrl('/members')      => 'https://api.atlantacardsharks.com/api/members' (prod) or '/api/members' (dev)
 *   getApiUrl('/api/members')  => 'https://api.atlantacardsharks.com/api/members' (prod) or '/api/members' (dev)
 */
export function getApiUrl(path: string): string {
  const base = getApiBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const apiPath = cleanPath.startsWith('/api/') || cleanPath === '/api'
    ? cleanPath
    : `/api${cleanPath}`;

  return `${base}${apiPath}`;
}
